import {apiSlice} from "../../app/api/apiSlice";
import {ASK_CODE, CURRENT_USER, LOGIN} from "../../repository"
export const authApiSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        login: builder.mutation({
            query: credentials => ({
                url: LOGIN,
                method: "POST",
                body: {...credentials}
            })
        }),
        askCode: builder.mutation({
            query: credentials => ({
                url: ASK_CODE,
                method: "POST",
                body: {...credentials}
            })
        }),
        getMe: builder.query({
            query: () => ({
                url: CURRENT_USER,
                method: "GET"
            })
        }),
    })
})

export const {
    useLoginMutation,
    useAskCodeMutation,
    useGetMeQuery
} = authApiSlice